export const LIST = "LUCKY_SPIN_HISTORY_LIST";
export const DROPDOWN = "LUCKY_SPIN_HISTORY_DROPDOWN";
export const DETAILS = "LUCKY_SPIN_HISTORY_DETAILS";
export const UPDATE = "LUCKY_SPIN_HISTORY_UPDATE";